export default __webpack_public_path__ + "static/media/Background_00059.dd08e40c.png";